const flexMap = {
  40: [
    {
      flex: [
        { 10: [101.6, 116.84] },
        { 20: [119.38, 134.62] },
        { 30: [137.16, 147.32] },
        { 40: [149.86, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  45: [
    {
      flex: [
        { 10: [101.6, 116.84] },
        { 20: [119.38, 134.62] },
        { 30: [137.16, 147.32] },
        { 40: [149.86, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  50: [
    {
      flex: [
        { 10: [101.6, 116.84] },
        { 20: [119.38, 134.62] },
        { 30: [137.16, 147.32] },
        { 40: [149.86, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  55: [
    {
      flex: [
        { 10: [101.6, 116.84] },
        { 20: [119.38, 134.62] },
        { 30: [137.16, 147.32] },
        { 40: [149.86, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  65: [
    {
      flex: [
        { 20: [101.6, 134.62] },
        { 30: [137.16, 147.32] },
        { 40: [149.86, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  80: [
    {
      flex: [
        { 20: [101.6, 129.54] },
        { 30: [132.08, 144.78] },
        { 40: [149.86, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  90: [
    {
      flex: [
        { 20: [101.6, 121.92] },
        { 30: [124.46, 134.62] },
        { 40: [137.16, 154.94] },
        { 50: [157.48, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  105: [
    {
      flex: [
        { 30: [101.6, 127] },
        { 40: [129.54, 142.24] },
        { 50: [144.78, 162.56] },
        { 55: [165.1, 175.26] },
        { 65: [177.8, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  110: [
    {
      flex: [
        { 40: [101.6, 142.24] },
        { 50: [144.78, 162.56] },
        { 55: [165.1, 170.08] },
        { 65: [172.72, 180.34] },
        { SR65: [182.89, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  115: [
    {
      flex: [
        { 40: [101.6, 127] },
        { 50: [129.4, 149.86] },
        { 55: [154.94, 167.64] },
        { 65: [170.18, 170.21] },
        { SR65: [172.7, 182.91] },
        { 70: [185.4, 187.96] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  120: [
    {
      flex: [
        { 50: [101.6, 149.86] },
        { 55: [154.94, 165.1] },
        { 65: [167.64, 170.2] },
        { SR65: [172.7, 185.4] },
        { 70: [179.9, 180.1] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  125: [
    {
      flex: [
        { 50: [101.6, 127] },
        { 55: [129.54, 157.48] },
        { 65: [160.02, 170.18] },
        { SR65: [172.7, 188] },
        { 77: [190.5, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  130: [
    {
      flex: [
        { 50: [101.6, 127] },
        { 55: [129.54, 154.94] },
        { 65: [157.48, 170.18] },
        { SR65: [172.7, 180.3] },
        { 70: [182.9, 185.42] },
        { 77: [187.96, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  135: [
    {
      flex: [
        { 50: [101.6, 127] },
        { 55: [129.54, 154.94] },
        { 65: [157.48, 167.64] },
        { SR65: [172.7, 180.3] },
        { 70: [170.18, 185.42] },
        { 77: [187.96, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  140: [
    {
      flex: [
        { 50: [101.6, 127] },
        { 55: [129.54, 149.86] },
        { 65: [154.94, 167.64] },
        { SR65: [170.2, 172.7] },
        { 70: [175.3, 185.42] },
        { 77: [187.96, 200.66] },
        { 82: [203.2, 205.74] },
      ],
    },
  ],
  145: [
    {
      flex: [
        { 55: [101.6, 149.86] },
        { 65: [154.94, 167.64] },
        { SR65: [170.2, 172.7] },
        { 70: [175.3, 182.88] },
        { 77: [185.42, 193.04] },
        { 82: [195.58, 205.74] },
      ],
    },
  ],
  150: [
    {
      flex: [
        { 55: [101.6, 149.86] },
        { 65: [154.94, 167.64] },
        { SR65: [170.1, 170.3] },
        { 70: [172.7, 182.88] },
        { 77: [185.42, 190.5] },
        { 82: [193.04, 205.74] },
      ],
    },
  ],
  155: [
    {
      flex: [
        { 55: [101.6, 149.86] },
        { 65: [154.94, 162.56] },
        { SR65: [165.1, 167.6] },
        { 70: [170.2, 177.8] },
        { 77: [180.34, 187.98] },
        { 82: [190.5, 203.2] },
        { 87: [203.3, 205.74] },
      ],
    },
  ],
  160: [
    {
      flex: [
        { 55: [101.6, 127] },
        { 65: [129.54, 160.02] },
        { SR65: [162.6, 165.1] },
        { 70: [170.2, 175.26] },
        { 77: [177.8, 185.42] },
        { 82: [187.96, 195.58] },
        { 87: [198.12, 205.74] },
      ],
    },
  ],
  165: [
    {
      flex: [
        { 65: [101.6, 157.48] },
        { SR65: [160, 162.6] },
        { 70: [165.1, 172.72] },
        { 77: [175.26, 182.88] },
        { 82: [185.42, 190.5] },
        { 87: [193.04, 205.74] },
      ],
    },
  ],
  170: [
    {
      flex: [
        { 65: [101.6, 129.54] },
        { SR65: [132.1, 160] },
        { 70: [162.6, 167.64] },
        { 77: [170.18, 180.34] },
        { 82: [182.88, 187.96] },
        { 87: [190.5, 205.74] },
      ],
    },
  ],
  175: [
    {
      flex: [
        { 65: [101.6, 129.54] },
        { SR65: [132.1, 147.3] },
        { 70: [149.9, 165.1] },
        { 77: [167.64, 175.26] },
        { 82: [177.8, 185.42] },
        { 87: [187.96, 205.74] },
      ],
    },
  ],
  180: [
    {
      flex: [
        { 65: [101.6, 129.54] },
        { SR65: [132.1, 147.3] },
        { 70: [132.02, 162.56] },
        { 77: [165.1, 172.72] },
        { 82: [175.26, 180.34] },
        { 87: [182.88, 203.2] },
        { 95: [203.3, 205.74] },
      ],
    },
  ],
  185: [
    {
      flex: [
        { SR65: [101.6, 139.7] },
        { 70: [142.2, 160] },
        { 77: [162.56, 170.18] },
        { 82: [172.72, 177.8] },
        { 87: [180.34, 200.66] },
        { 95: [203.2, 205.74] },
      ],
    },
  ],
  190: [
    {
      flex: [
        { 70: [101.6, 124.48] },
        { SR65: [127, 134.5] },
        { 70: [137.2, 157.48] },
        { 77: [160.02, 167.64] },
        { 82: [170.18, 175.26] },
        { 87: [177.8, 198.12] },
        { 95: [200.66, 205.74] },
      ],
    },
  ],
  195: [
    {
      flex: [
        { 70: [101.6, 154.94] },
        { SR65: [127, 132.1] },
        { 70: [134.6, 154.9] },
        { 77: [157.48, 165.1] },
        { 82: [167.64, 172.72] },
        { 87: [175.26, 195.58] },
        { 95: [198.12, 205.74] },
      ],
    },
  ],
  200: [
    {
      flex: [
        { 77: [101.6, 160.02] },
        { 82: [162.56, 170.18] },
        { 87: [172.72, 193.04] },
        { 95: [195.58, 203.2] },
        { 102: [203.3, 205.74] },
      ],
    },
  ],
  205: [
    {
      flex: [
        { 77: [101.6, 157.48] },
        { 82: [160.02, 167.64] },
        { 87: [170.18, 190.5] },
        { 95: [193.04, 203.2] },
        { 102: [203.3, 205.74] },
      ],
    },
  ],
  210: [
    {
      flex: [
        { 77: [101.6, 149.86] },
        { 82: [154.94, 165.1] },
        { 87: [167.64, 187.96] },
        { 95: [190.5, 200.66] },
        { 102: [203.2, 205.74] },
      ],
    },
  ],
  215: [
    {
      flex: [
        { 77: [101.6, 142.24] },
        { 82: [144.78, 162.56] },
        { 87: [165.1, 185.42] },
        { 95: [187.96, 198.12] },
        { 102: [200.66, 205.74] },
      ],
    },
  ],
  220: [
    {
      flex: [
        { 77: [101.6, 137.16] },
        { 82: [139.7, 157.48] },
        { 87: [160.02, 182.88] },
        { 95: [185.42, 195.58] },
        { 102: [198.12, 205.74] },
      ],
    },
  ],
  225: [
    {
      flex: [
        { 77: [101.6, 134.62] },
        { 82: [137.16, 144.78] },
        { 87: [147.32, 180.34] },
        { 95: [182.88, 193.04] },
        { 102: [195.58, 205.74] },
      ],
    },
  ],
  230: [
    {
      flex: [
        { 77: [101.6, 132.08] },
        { 82: [134.62, 142.24] },
        { 87: [144.78, 177.8] },
        { 95: [180.34, 190.5] },
        { 102: [193.04, 205.74] },
      ],
    },
  ],
  235: [
    {
      flex: [
        { 77: [101.6, 129.54] },
        { 82: [132.08, 137.16] },
        { 87: [139.7, 172.72] },
        { 95: [175.26, 187.96] },
        { 102: [190.5, 205.74] },
      ],
    },
  ],
  240: [
    {
      flex: [
        { 82: [101.6, 132.08] },
        { 87: [134.62, 167.64] },
        { 95: [170.18, 185.42] },
        { 102: [187.96, 203.2] },
        { 112: [203.3, 205.74] },
      ],
    },
  ],
  245: [
    {
      flex: [
        { 82: [101.6, 129.54] },
        { 87: [132.08, 162.56] },
        { 95: [165.1, 180.34] },
        { 102: [182.88, 200.66] },
        { 112: [203.2, 205.74] },
      ],
    },
  ],
  250: [
    {
      flex: [
        { 87: [101.6, 157.48] },
        { 95: [160.02, 175.26] },
        { 102: [177.8, 198.12] },
        { 112: [200.66, 205.74] },
      ],
    },
  ],
  255: [
    {
      flex: [
        { 87: [101.6, 149.86] },
        { 95: [154.94, 170.18] },
        { 102: [172.72, 193.04] },
        { 112: [195.58, 205.74] },
      ],
    },
  ],
  260: [
    {
      flex: [
        { 87: [101.6, 142.24] },
        { 95: [144.78, 165.1] },
        { 102: [167.64, 187.96] },
        { 112: [190.5, 205.74] },
      ],
    },
  ],
  265: [
    {
      flex: [
        { 87: [101.6, 139.7] },
        { 95: [142.24, 160.02] },
        { 102: [162.56, 185.42] },
        { 112: [187.96, 205.74] },
      ],
    },
  ],
  270: [
    {
      flex: [
        { 87: [101.6, 137.16] },
        { 95: [139.7, 149.86] },
        { 102: [154.94, 182.88] },
        { 112: [185.42, 205.74] },
      ],
    },
  ],
  275: [
    {
      flex: [
        { 87: [101.6, 132.08] },
        { 95: [134.62, 144.78] },
        { 102: [147.32, 177.8] },
        { 112: [180.34, 205.74] },
      ],
    },
  ],
  280: [
    {
      flex: [
        { 95: [101.6, 139.7] },
        { 102: [142.24, 172.72] },
        { 112: [175.26, 205.74] },
      ],
    },
  ],
  285: [
    {
      flex: [
        { 95: [101.6, 134.62] },
        { 102: [137.16, 167.64] },
        { 112: [170.18, 205.74] },
      ],
    },
  ],
  290: [
    {
      flex: [{ 102: [101.6, 162.56] }, { 112: [165.1, 205.74] }],
    },
  ],
  300: [
    {
      flex: [{ 102: [101.6, 157.48] }, { 112: [165.1, 205.74] }],
    },
  ],
  305: [
    {
      flex: [{ 102: [101.6, 149.86] }, { 112: [154.94, 205.74] }],
    },
  ],
  310: [
    {
      flex: [{ 102: [101.6, 144.78] }, { 112: [147.32, 205.74] }],
    },
  ],
};

export default flexMap;
